<template>
  <!-- keyed on the uid: opening another customer builds a new form, so nothing of the
       last customer (a delivery instruction, a note) carries over to the next one -->
  <CustomerDetail ref="detail" :key="id" :id="id" v-bind="$attrs"/>
</template>

<script>
import CustomerDetail from "@/components/CustomerDetail";

export default {
  name: "Customer",
  components: {CustomerDetail},
  inheritAttrs: false,
  props: {
    id: {type: String, required: true},
  },
  methods: {
    hasUnsavedChanges() {
      const detail = this.$refs.detail;
      return !!(detail && detail.hasUnsavedChanges);
    },
  },
  // route guards run on the route's component only, so they live here rather than in CustomerDetail
  beforeRouteLeave(to, from, next) {
    if (this.hasUnsavedChanges() && !confirm('You have unsaved changes. Leave without saving?')) {
      return next(false);
    }
    next();
  },
  beforeRouteUpdate(to, from, next) {
    // Only prompt when the customer actually changes; tab clicks update query params via urlState
    // and would otherwise fire this guard unnecessarily.
    if (to.params.id === from.params.id) {
      return next();
    }
    if (this.hasUnsavedChanges() && !confirm('You have unsaved changes. Load another customer without saving?')) {
      return next(false);
    }
    next();
  },
}
</script>
